export default ({typeId}) => `
${typeId ? `
    <span class="title-format-badge contrast u-allCaps"><i class="icon-${typeId}"></i>${window.html(typeId)}</span>
` : '' }
`;
